import CountUp from "react-countup";
import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";

const FALLBACK = [
  { label: "Talentos en red", value: 25, suffix: "+" },
  { label: "Campañas producidas", value: 80, suffix: "+" },
  { label: "Ciudades activas", value: 9, suffix: "" },
  { label: "Audiencia combinada", value: 12, suffix: "M+" },
  { label: "Streamings en vivo", value: 50, suffix: "+" },
];

export default function ImpactSection() {
  const { config } = useSite();
  const stats = config?.impact_stats?.length ? config.impact_stats : FALLBACK;

  return (
    <section className="py-24 lg:py-32 relative" data-testid="impact-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4 font-bold">Impacto</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1] mb-6">
            Una red que <span className="gradient-text">mueve audiencias</span> reales.
          </h2>
          <p className="text-base text-muted-foreground leading-relaxed">
            Producción local, contenido multiplataforma, streaming en vivo y campañas medibles. Todo en una sola red nacional.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-border border border-border rounded-sm overflow-hidden">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-background p-6 lg:p-8 hover:bg-secondary/50 transition-colors"
              data-testid={`impact-stat-${i}`}
            >
              <div className="font-display text-4xl lg:text-5xl font-black tracking-tighter mb-2">
                <CountUp end={s.value} duration={2.4} enableScrollSpy scrollSpyOnce suffix={s.suffix || ""} />
              </div>
              <div className="text-xs uppercase tracking-[0.15em] text-muted-foreground font-semibold">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
